<template>
  <NxSelectReduced
    :value="localValue"
    :options="filteredOptions"
    labelText="Período de Referência:"
    id="selectPeriodoReferencia"
    placeholder="Selecione o Período"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'
import { ListGoalPeriods } from '@/enums/enumGoalMetricTypes.js'

export default {
  name: 'NxSelectReferenciaPeriodo',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    initialValue: {
      required: false
    },
    value: {
      required: true
    },
    tipo: {
      type: String,
      required: true,
      validator (value) {
        return [ListGoalPeriods.MENSAL, ListGoalPeriods.BIMESTRAL, ListGoalPeriods.TRIMESTRAL].includes(value)
      }
    }
  },
  mounted () {
    if (this.initialValue !== undefined && this.initialValue !== null && this.filteredOptions.length > 0) {
      this.localValue = this.initialValue
    } else {
      this.localValue = this.value
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
    }
  },
  data () {
    return {
      listOptions: {
        0: [
          {value: 1, text: 'Janeiro'},
          {value: 2, text: 'Fevereiro'},
          {value: 3, text: 'Março'},
          {value: 4, text: 'Abril'},
          {value: 5, text: 'Maio'},
          {value: 6, text: 'Junho'},
          {value: 7, text: 'Julho'},
          {value: 8, text: 'Agosto'},
          {value: 9, text: 'Setembro'},
          {value: 10, text: 'Outubro'},
          {value: 11, text: 'Novembro'},
          {value: 12, text: 'Dezembro'}
        ],
        1: [
          {value: 1, text: '1º Bimestre (Jan - Fev)'},
          {value: 2, text: '2º Bimestre (Mar - Abr)'},
          {value: 3, text: '3º Bimestre (Mai - Jun)'},
          {value: 4, text: '4º Bimestre (Jul - Ago)'},
          {value: 5, text: '5º Bimestre (Set - Out)'},
          {value: 6, text: '6º Bimestre (Nov - Dez)'}
        ],
        2: [
          {value: 1, text: '1º Trimestre (Jan - Mar)'},
          {value: 2, text: '2º Trimestre (Abr - Jun)'},
          {value: 3, text: '3º Trimestre (Jul - Set)'},
          {value: 4, text: '4º Trimestre (Out - Dez)'}
        ]
      },
      localValue: null
    }
  },
  computed: {
    filteredOptions () {
      return this.listOptions[this.tipo]
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectReferenciaPeriodo.vue